import { PlateElement } from 'platejs/react';
import { useTocElement, useTocElementState } from '@platejs/toc/react';
import styles from './TocElement.module.scss';

const LEVEL_INDENT: Record<number, string> = { 1: styles.indent1, 2: styles.indent2, 3: styles.indent3 };

// Renders the TOC block as an inline-document element. The heading list is
// derived live from the editor via useTocElementState (re-renders on heading
// changes). Clicking a heading item scrolls the editor to that heading.
//
// Zero-headings: renders a placeholder row so the user knows the block is
// there and can select/delete it. This prevents an invisible void block.
export function TocElement(props: any) {
    const state = useTocElementState();
    const {
        props: { onClick },
    } = useTocElement(state);
    const { headingList } = state;

    return (
        <PlateElement {...props} as="nav" className={styles.toc}>
            <div contentEditable={false} className={styles.inner}>
                <div className={styles.label}>Table of contents</div>
                {headingList.length === 0 ? (
                    <div className={styles.empty}>No headings yet — add H1, H2, or H3 above.</div>
                ) : (
                    <ul className={styles.list}>
                        {headingList.map((item, index) => (
                            <li
                                key={item.id ?? `${item.title}-${item.depth}-${index}`}
                                className={`${styles.item} ${LEVEL_INDENT[item.depth] ?? styles.indent3}`}
                            >
                                <button
                                    type="button"
                                    className={styles.link}
                                    onClick={(e) => {
                                        const target = e.currentTarget as HTMLElement;
                                        onClick(e as any, item, 'smooth');
                                        // Prevent the click from stealing editor focus away from
                                        // the freshly-scrolled heading.
                                        target.blur();
                                    }}
                                >
                                    {item.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            {/* Plate void marker — must be rendered by PlateElement children. */}
            {props.children}
        </PlateElement>
    );
}
